import { StringValueId } from '../../shared/filters/filter-supported-type.model';
import { PageModel } from './page.model';

export class CategoryFiltersResponseDto<T extends StringValueId[]> {
  name: string;
  items: T;
}

export interface ArrayCategoryFilter<T extends StringValueId> {
  values: T[];
}

export class CategoryFiltersRequestDto {
  paging: PageModel;
  minOffset: number;
  maxOffset: number;
  archive: boolean;

  constructor() {
    // djb: 567
    // this.paging = null;
    this.paging = new PageModel;
  }
}

export class GenericStringValueIdCategoryFilter implements ArrayCategoryFilter<StringValueId> {
  values: StringValueId[];
}

export class DecimalCategoryFilter implements GenericStringValueIdCategoryFilter {
  values: StringValueId[];
}

export class StringCategoryFilter implements GenericStringValueIdCategoryFilter {
  values: StringValueId[];
}

export class StringValueIdCategoryFilter implements GenericStringValueIdCategoryFilter {
  values: StringValueId[];
}

export class SingleGenericStringValueIdCategoryFilter {
  value: StringValueId;
}
